export enum GSMSubdomain {
  HTZ = "htz",
  QPM = "qpm",
  RLT = "rlt",
  Textblocks = "textblocks",
  VBS = "vbs",
}
